var map = {
	"./audio-placeholder": 707,
	"./audio-placeholder.png": 707,
	"./avatar-missing": 477,
	"./avatar-missing.png": 477,
	"./avatar-missing.svg": 984,
	"./header-missing": 480,
	"./header-missing.png": 480,
	"./soapbox-logo": 481,
	"./soapbox-logo-white": 482,
	"./soapbox-logo-white.svg": 482,
	"./soapbox-logo.svg": 481,
	"./video-placeholder": 708,
	"./video-placeholder.png": 708,
	"./void": 709,
	"./void.png": 709,
	"./web-push/web-push-icon_expand": 782,
	"./web-push/web-push-icon_expand.png": 782,
	"./web-push/web-push-icon_favourite": 783,
	"./web-push/web-push-icon_favourite.png": 783,
	"./web-push/web-push-icon_reblog": 784,
	"./web-push/web-push-icon_reblog.png": 784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 983;